export const selectDraftDesign = state => state.designer.draftDesign;
